import React from 'react';
import { Link } from 'gatsby';
import instagramSvg from '../resource/instagram-logo.svg';
import Search from './Search';

export default () => {
  return (
    <div
      css={`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        height: 3rem;

        > * {
          border-right: 1px solid black;
          border-bottom: 1px solid black;
        }

        @media only screen and (max-width: 768px) {
          grid-template-columns: 1fr 1fr;
          height: 6rem;
        }
      `}
    >
      <Link
        to="/"
        css={`
          font-weight: 700;
          display: flex;
          align-items: center;
          padding: 0 1rem;
        `}
      >
        PUBLIO
      </Link>
      <div
        css={`
          height: 100%;
          display: flex;
          align-items: center;
          position: relative;
          @media only screen and (max-width: 768px) {
            grid-column: 1 / 3;
            grid-row: 2;
          }
        `}
      >
        <Search />
      </div>
      <div
        css={`
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 1rem;
        `}
      >
        <a href="https://instagram.com/publio.official" target="blank">
          @publio.official
        </a>
        <img src={instagramSvg} alt="" css="height: 1.4rem;" />
      </div>
    </div>
  );
};
